import {AxiosInstance} from "axios";
import {ShellUpdateOffer} from "@/shell-update/interfaces";

const ShellUpdateResource = (client: AxiosInstance) => {
    return {
        /**
         * Get the shell update offered to a Connect.
         *
         * @param version The version of the Connect shell.
         */
        async offer(version: string): Promise<ShellUpdateOffer> {
            return client.get("connect/shell-update", {params: {version}})
                .then((response) => response.data.data);
        },

        /**
         * Schedule the shell update for every workstation of the pharmacy.
         *
         * @param version The version of the Connect shell asking.
         */
        async schedule(version: string): Promise<ShellUpdateOffer> {
            return client.post("connect/shell-update/requests", {version})
                .then((response) => response.data.data);
        }
    };
};

export default ShellUpdateResource;
